import { List, Map, fromJS } from 'immutable';

export function request(state, { id, name }) {
    id = parseInt(id, 10);

    let assetFlows = state.get('assetFlows') || Map();
    let user = assetFlows.get(id) || Map();

    user = user.set(
        name,
        (user.get(name) || Map())
            .set('state', 'IN_PROGRESS')
            .set('errors', void 0)
    );

    return state.set(
        'assetFlows', assetFlows.set(id, user)
    );
}

export function error(state, { id, name, errors }) {
    id = parseInt(id, 10);

    let assetFlows = state.get('assetFlows') || Map();
    let user = assetFlows.get(id) || Map();

    user = user.set(
        name,
        (user.get(name) || Map())
            .set('list', List())
            .set('state', 'ERROR')
            .set('errors', fromJS(errors))
    );

    return state.set(
        'assetFlows', assetFlows.set(id, user)
    );
}

export function finish(state, { id, name, assetFlows }) {
    id = parseInt(id, 10);

    let assetFlowsEl = state.get('assetFlows') || Map();
    let user = assetFlowsEl.get(id) || Map();

    user = user.set(
        name,
        (user.get(name) || Map())
            .set('list', fromJS(assetFlows))
            .set('state', 'FINISHED')
            .set('errors', void 0)
    );

    return state.set(
        'assetFlows', assetFlowsEl.set(id, user)
    );
}

export function clear(state) {
    return state.set('assetFlows', Map());
}
